module.exports = __webpack_public_path__ + "static/media/Asset 7.2@3x.beb3f783.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 7.2@3x.png
// module id = 2399
// module chunks = 0